import React, {useState} from 'react';
import {useAppSelector} from "../../store/hooks";
import {selectInEstateCnwAssetTotals, selectInEstateCnwAssetTotalsUsingDeathBenefit} from "../clientAssetsSlice";
import {AssetsView} from "../common/AssetsView";
import AssetsViewContext from "../common/AssetsViewContext";
import useAnalytics from "../../utils/useAnalytics";

const CurrentNetWorthContainer = () => {

    const [showDeathBenefit, setShowAtDeathBenefit] = useState(false);//not in ASM
    const inEstateCnwAssetTotals = useAppSelector(showDeathBenefit ? selectInEstateCnwAssetTotalsUsingDeathBenefit : selectInEstateCnwAssetTotals)!;

    useAnalytics(
        "Navigate_CurrentNWPage",
        "Navigate_CurrentNWPage_TimeSpent",
        "enableAssetsGoogleAnalytics"
    );

    return (
        <AssetsViewContext.Provider value="CurrentNetWorth">
            <AssetsView inEstateTotals={inEstateCnwAssetTotals}
                        showDeathBenefit={showDeathBenefit}
                        toggleShowDeathBenefit={() => setShowAtDeathBenefit(!showDeathBenefit)}
            />
        </AssetsViewContext.Provider>
    );
}

export default CurrentNetWorthContainer;